import _ from 'lodash';
import {RollOverTypes, ContributionValues} from '../constants/FundingYourProductConstants';
import {AccountTypeCodes, YesNoValues, ProductIds} from '../constants/ApplicationConstants.js';
import IncomeDistributionConstants from '../constants/IncomeDistributionConstants';
import YourDetailsConstants from '../constants/YourDetailsConstants';
import DateTime from './DateTime.js';

// Triggers, numbered according to wireframes
// 01
// Internal rollover selected (note: this includes manually entered funds)
function internalRollover(data, content) {
    let fileNote = [];
    const hasInternalRollover = _.filter(data.fundingYourProduct.fundingSources, (f) => {
        return f.rollOverType === RollOverTypes.INTERNAL;
    });
    if (hasInternalRollover && hasInternalRollover.length > 0) {
        fileNote.push({
            id: 'FILENOTE_FYP_INTERNAL_ROLLOVER',
            containers: ['fundingYourProduct'],
            instructions: content.internalRollover
        });
    }

    return fileNote;
}

// 02
// currently a change request

// 03
// Special requests 'Yes' button is selected with text in text box
function specialRequest(data, content) {
    let fileNote = [];

    if(data.specialRequests && data.specialRequests.isWithSpecialRequests === YesNoValues.YES) {
        fileNote.push({
            id: 'FILENOTE_SPECIAL_REQUESTS',
            containers: ['specialRequests'],
            instructions: content.specialRequests
        });
    }

    return fileNote;
}

//removed for r47.1 as FMS can handle the pin generation
// 04
// Yes is selected in Online access
//function onlineAccess(data, content) {
//    let fileNote = [];

//    // generate online access CTA only for applications originated via FNA
//    if(window.NOA.userContext.isAdviser && data.onlineAccess && data.onlineAccess.length > 0 && data.onlineAccess[0].grantOnlineAccess === YesNoValues.YES) {
//        fileNote.push({
//            id: 'FILENOTE_ONLINE_ACCESS',
//            containers: ['onlineAccess'],
//            instructions: content.onlineAccess
//        });
//    }

//    return fileNote;
//}

//05
// Personal contribution (direct debit) selected
function personalContributionDirectDebit(data, content) {
    let fileNote = [];

    const hasPersonalContributionDD = _.filter(data.fundingYourProduct.fundingSources, (f) => {
        return f.paymentMethod === ContributionValues.DIRECT_D;
    });
    if(hasPersonalContributionDD && hasPersonalContributionDD.length > 0) {
        fileNote.push({
            id: 'FILENOTE_FYP_PERSONAL_CONTRIB_DIRECT_DEBIT',
            title: 'Funding your application (direct debit)',
            wrap: true,
            containers: ['personalContribution', 'fypConfirmTotal','bankAccountDetails'],
            instructions: content.personalContribDirectDebitSuper
        });
    }

    return fileNote;
}

// 08
// removed for r48 as FMS already handles this scenario
// under 65 retirement benefit - preservation age selection made
//function pensionType(data, content) {
//    let fileNote = [];
//    if (data.pensionType && data.pensionType.selectedBenefitItem === BenefitSelectionNames.RETIREMENT_PRESERVE_AGE) {
//        fileNote.push({
//            id: 'FILENOTE_PENSION_TYPE',
//            containers: ['pensionType'],
//            instructions: content.under65Retirement
//        });
//    }

//    return fileNote;
//}

// 09
// When there is a Tax residence details included in My details section.
function taxResidence(data, content) {
    let fileNote = [];

    var taxResidence = [];
    if (data.yourDetails.taxResidence && 
        data.yourDetails.taxResidence.countries && 
        data.yourDetails.taxResidence.countries.length > 0) {
        taxResidence.push(data.yourDetails.taxResidence);
    }
    
    if (data.yourDetails.investorList && data.yourDetails.investorList.length > 0) {
        _.each(data.yourDetails.investorList,
            (investor) => {
                if (investor.taxResidence && 
                    investor.taxResidence.countries && 
                    investor.taxResidence.countries.length > 0) {
                    taxResidence.push(investor.taxResidence);
                }
            });
    }

    if (data.yourDetails.trusteeList && data.yourDetails.trusteeList.length > 0) {
        _.each(data.yourDetails.trusteeList,
            (trustee) => {
                if (trustee.taxResidence && 
                    trustee.taxResidence.countries && 
                    trustee.taxResidence.countries.length > 0) {
                    taxResidence.push(trustee.taxResidence);
                }
                
            });
    }

    if(taxResidence.length > 0){
            fileNote.push({
                id: 'FILENOTE_USA_ADDRESS',
                title: 'Country of tax residence',
                querySelectorAll: '.yourDetails .row',
                querySelectorLabels: [
                    // Label is varying based on account type. Try to select any available label
                    YourDetailsConstants.Labels.otherCountryTaxResidence, YourDetailsConstants.Labels.otherCountryTaxResidenceInvestment, YourDetailsConstants.Labels.tin.label, YourDetailsConstants.Labels.tin.tinExemptionReason,
                    YourDetailsConstants.Labels.otherCountryTaxResidence + ' #1', YourDetailsConstants.Labels.otherCountryTaxResidenceInvestment + ' #1', YourDetailsConstants.Labels.tin.label + ' #1', YourDetailsConstants.Labels.tin.tinExemptionReason + ' #1',
                    YourDetailsConstants.Labels.otherCountryTaxResidence + ' #2', YourDetailsConstants.Labels.otherCountryTaxResidenceInvestment + ' #2', YourDetailsConstants.Labels.tin.label + ' #2', YourDetailsConstants.Labels.tin.tinExemptionReason + ' #2',
                    YourDetailsConstants.Labels.otherCountryTaxResidence + ' #3', YourDetailsConstants.Labels.otherCountryTaxResidenceInvestment + ' #3', YourDetailsConstants.Labels.tin.label + ' #3', YourDetailsConstants.Labels.tin.tinExemptionReason + ' #3'
                ],
                wrap: true,
                outerSelector: true, 
                includeSelector: '.confirm-sub-section-heading',
                instructions: content.usaAddress
            });
    }
   
    return fileNote;
}


// 10
// Manual address entered in My details (Potential c/o address) (was TBC)
// Manual address entered in My details (Potential c/o address)
// FIXME: where is this?
function manualAddress(data, content) {
    let fileNote = [],
        isAddressManualEntry = false;

    if (data.yourDetails.investorList && data.yourDetails.investorList.length > 0) {
        // this means, there are multiple yourDetails data to consider
        _.forEach(data.yourDetails.investorList, (element) => {
            isAddressManualEntry = isAddressManualEntry || verifyManualAddressEntered(element);
        });
    }
    else {
        isAddressManualEntry = verifyManualAddressEntered(data.yourDetails);
    }

    if (isAddressManualEntry) {
        fileNote.push({
            id: 'FILENOTE_MANUAL_ADDRESS',
            title: 'Address details - manually entered address',
            hideSectionHeader: true,
            containers: ['yourDetails'],
            instructions: content.manualAddress
        });
    }

    return fileNote;
}

function verifyManualAddressEntered(address) {
    let isResAddressManualEntry = false,
        isPostalAddressManualEntry = false;

    isResAddressManualEntry = address.residentialAddress && !address.residentialAddress.isResAddressFound;
    if (address.postalAddress) {
        isPostalAddressManualEntry = (address.postalAddress.isSameAsResidentialAddress === YesNoValues.YES)
            ? isResAddressManualEntry
            : !address.postalAddress.isPostalAddressFound;
    }

    return isResAddressManualEntry || isPostalAddressManualEntry;
}

// 11
// Only term deposit selected
function termDepositInvestAllocation(data, content) {
    let fileNote = [];

    let hasTermDeposit = _.filter(data.investmentAllocation.investmentOptions, (i) => {
        return i.termDeposit;
    });
    hasTermDeposit = hasTermDeposit && hasTermDeposit.length > 0;

    if (hasTermDeposit) {
        fileNote.push({
            id: 'FILENOTE_TERM_DEPOSIT',
            title: 'Term deposit selected',
            containers: ['investmentAllocation', 'portfolioRebate', 'fundingYourProduct', 'adviserFee'],
            instructions: content.termDeposit
        });
    }

    return fileNote;
}

//12
// Income distribution and non-funding bank account
function incomeDistributionNonFunding(data, content) {
    let fileNote = [];

    if (data.incomeDistribution && data.incomeDistribution.paymentMethod === IncomeDistributionConstants.bankAccountText) {
        fileNote.push({
            id: 'FILENOTE_INVESTMENT_INCOME_DISTRIBUTION',
            containers: ['incomeDistribution'],
            instructions: content.incomeDistributionNonFunding
        });
    }

    return fileNote;
}

// 13
// // In-specie selection
function inSpecieSelection(data, content) {
    let fileNote = [];
    const containers = ['fundingYourProduct', 'inSpecieTransfer', 'investmentAllocation'];

    // Refer to https://confluence.prod.cba/display/FAM/NOA-XXX+-+%5BIn+specie+transfer%5D+Enable+In+Specie+transfer+functionality
    // Given In Specie transfer functionality is applicable, call to action should display the inspecie section and investment allocation.

    if (_.get(data, 'fundingYourProduct.fundingSources', null) && _.get(data,'inSpecieTransfer.setUp', null) === YesNoValues.YES){
        fileNote.push({
            id: 'FILENOTE_PENSION_IN_SPECIE_TRANSFER',
            containers: containers,
            instructions: content.inSpecieSelection
        });
    }

    return fileNote;
}


//14
// If user has specified more than one payment (excl Internal transfer) to fund their ...
// ... Investment product, only first payment will be sent to FMS. The remaining payment methods will generate a work item. (was TBC)
function fundingInvestment(data, content) {
    let fileNote = [];

    const nonInternalTransfers = _.filter(data.fundingYourProduct.fundingSources, (f) => {
        // filter only those that are NOT INTERNAL_TRANSFER
        return f.rollOverType !== RollOverTypes.INTERNAL && f.paymentMethod !== ContributionValues.INTERNAL_TRANSFER;
    });
    const validfundingPayments = nonInternalTransfers && nonInternalTransfers.length > 1;

    if (validfundingPayments) {
        fileNote.push({
            id: 'FILENOTE_INVESTMENT_FUNDING_PAYMENT',
            containers: ['fundingYourProduct'],
            instructions: content.multiplePayments
        });
    }

    return fileNote;
}


//15
// If account is a Joint account type
function jointAccountType(data, content) {
    let fileNote = [];

    if(data.accountType === AccountTypeCodes.JOINT) {
        fileNote.push({
            id: 'FILENOTE_INVESTMENT_JOINT_YOUR_DETAILS',
            title: 'My details',
            containers: ['portfolioRebate'],
            querySelectorAll: '.yourDetails .row',
            querySelectorLabels: [YourDetailsConstants.Labels.name, YourDetailsConstants.Labels.fullname, YourDetailsConstants.Labels.emailAddress],
            includeSelector: '.confirm-sub-section-heading',
            wrap: true,
            instructions: content.jointAccount
        });
    }

    return fileNote;
}

// 16
// one-off Adviser fees applied
// Updated for r47.1, only create filenote when one-off advice fees are present, ongoing advice fees are handled by FMS.
// Removed for r48.0 as FMS can handle this
//function adviserFee(data, content) {
//    let fileNote = [];
//    const adviceFee = _.filter(data.adviceFee.AdviceFeesList, (a) => {
//        return a.frequency === AdviserFeeFrequencies.ONEOFF && a.feeType === AdviserFeeTypes.ASF
//    });
//    const hasAdviserFee = adviceFee && adviceFee.length > 0;
    
//    if (hasAdviserFee) {
//        fileNote.push({
//            id: 'FILENOTE_ADVISER_FEE',
//            containers: ['adviserFee'],
//            instructions: content.adviserFeesApplied
//        });
//    }

//    return fileNote;
//}

// 17
// Pension payment draw down option/Payment frequency/defer payment (was TBC)
function pensionPayment(data, content){
    let fileNote = [];

    // is always displayed because there is always default value for pensionPaymentDrawdown
    fileNote.push({
        id: 'FILENOTE_PENSION_PAYMENT',
        containers: ['pensionPayment'],
        instructions: content.pensionPaymentDrawdown
    });

    return fileNote;
}

//removed for r47.1 as FMS can handle this
// 18
// Adding TFN to FMCTM - consent (was TBC)
//function clientProvidedTfn(data, content) {
//    let fileNote = [];
//    if (data.yourDetails.tfnInfo.tfnNumber) {
//        fileNote.push({
//            id: 'FILENOTE_SUPER_TFN',
//            title: 'My details',
//            querySelectorAll: '.yourDetails .row',
//            querySelectorLabels: [YourDetailsConstants.Labels.tfnInfo.tfnNumber],
//            wrap: true,
//            instructions: content.addingTFNtoFMCTM,
//            replacePlaceHolder: _.get(data, 'yourDetails.tfnInfo.tfnPlaceHolder', null)
//        });
//    }
//    return fileNote;
//}

// 20
// Sole trader account type
function soleTraderAccountType(data, content) {
    let fileNote = [];

    if(data.accountType === AccountTypeCodes.SOLE_TRADER) {
        fileNote.push({
            id: 'FILENOTE_INVESTMENT_SOLE_TRADER_YOUR_DETAILS',
            title: 'Sole Trader business details',
            containers: ['yourDetails'],
            instructions: content.soleTraderAccount
        });
    }

    return fileNote;
}

// 21
// super first selected
function superFirstTransferSelected(data, content) {
    let fileNote = [];

    if (data.superFirstTransfer && data.superFirstTransfer.isSuperTransferSetup === YesNoValues.YES) {
        fileNote.push({
            id: 'FILENOTE_PENSION_SUPER_TRANSFER_FIRST',
            containers: ['superFirstTransfer'],
            instructions: content.superFirstTransferFlag
        });
    }

    return fileNote;
}

// 22
// Where to retrive? Third party account details in Pension Payment details
// Third party bank details in RIP section selected
function ripThirdPartyBankDetails(data, content) {
    let fileNote = [];

    if (data.regularInvestmentPlan && data.regularInvestmentPlan.ripOption === YesNoValues.YES) {
        fileNote.push({
            id: 'FILENOTE_RIP_THIRD_PARTY_DETAILS',
            containers: ['regularInvestmentPlan'],
            instructions: content.thirdPartyAccount
        });
    }

    return fileNote;
}

//23
//employment status should be present for:
// SUPER - Age is 65 and over
// PENSION - Age is 65 and over and SuperFirst is YES
function employmentStatus(data, content, dateToday, productId) {
    let fileNote = [],
        fileNoteRequired = false,
        over65 = false,
        age = 0;

    const yd = data.yourDetails;

    if (yd && yd.dateOfBirth) {
        age = DateTime.getAge(dateToday, yd.dateOfBirth);
        over65 = age >= 65;
    }

    switch (productId) {
        case ProductIds.SUPER:
            fileNoteRequired = over65;
            break;
        case ProductIds.PENSION:
            const hasSuperFirst = data.superFirstTransfer && data.superFirstTransfer.isSuperTransferSetup === YesNoValues.YES;
            fileNoteRequired = over65 && hasSuperFirst;
            break;
        case ProductIds.INVESTMENT:
        default:
            fileNoteRequired = false;
            break;
    }
    if (fileNoteRequired) {
        fileNote.push({
            id: 'FILENOTE_EMPLOYMENT_DETAILS',
            title: 'Employment details',
            querySelectorAll: '.yourDetails .row',
            querySelectorLabels: [YourDetailsConstants.Labels.occupation],
            instructions: content.employmentStatus,
            wrap: true
        });
    }

    return fileNote;
}

const FilenoteTriggers = {
    internalRollover: internalRollover,
    specialRequest: specialRequest,
    personalContributionDirectDebit: personalContributionDirectDebit,
    //pensionType: pensionType, //removed for r48.0 as FMS can handle this
    manualAddress: manualAddress,
    termDepositInvestAllocation: termDepositInvestAllocation,
    jointAccountType: jointAccountType,
    //adviserFee: adviserFee, // removed for r48.0 as FMS can handle this
    pensionPayment: pensionPayment,
    soleTraderAccountType: soleTraderAccountType,
    superFirstTransferSelected: superFirstTransferSelected,
    ripThirdPartyBankDetails: ripThirdPartyBankDetails,
    incomeDistributionNonFunding: incomeDistributionNonFunding,
    fundingInvestment: fundingInvestment,
    inSpecieSelection: inSpecieSelection,
    taxResidence: taxResidence,
    employmentStatus: employmentStatus
    //removed for r47.1 as FMS can handle this
    //onlineAccess: onlineAccess,
    //clientProvidedTfn: clientProvidedTfn,
};

export default FilenoteTriggers;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/WorkItemFilenoteTriggers.js